import React, { useEffect, useState } from 'react';
import { adminAuthService } from '../services';
import { notifyError, notifySuccess } from '../utils/toast';

const Profile = () => {
    const [profile, setProfile] = useState({ name: '', phone: '', bio: '' });
    const [passwords, setPasswords] = useState({ current_password: '', password: '', password_confirmation: '' });
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            const response = await adminAuthService.getCurrentUser();
            setProfile({
                name: response.data.name || '',
                phone: response.data.phone || '',
                bio: response.data.bio || '',
            });
        } catch (err) {
            console.error('Error fetching profile:', err);
            notifyError('Unable to load profile.');
        }
    };

    const handleProfileSave = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        try {
            await adminAuthService.updateProfile(profile);
            setMessage('Profile updated successfully.');
            notifySuccess('Profile updated successfully.');
        } catch (err) {
            setError(err.response?.data?.message || 'Unable to update profile.');
            notifyError(err.response?.data?.message || 'Unable to update profile.');
        }
    };

    const handlePasswordSave = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        try {
            await adminAuthService.changePassword(passwords);
            setMessage('Password changed successfully.');
            setPasswords({ current_password: '', password: '', password_confirmation: '' });
            notifySuccess('Password changed successfully.');
        } catch (err) {
            setError(err.response?.data?.message || 'Unable to change password.');
            notifyError(err.response?.data?.message || 'Unable to change password.');
        }
    };

    return (
        <div>
            <h1 className="mb-8 text-4xl font-bold text-gray-800">Profile</h1>
            {message && <div className="mb-4 rounded-lg bg-green-100 p-3 text-green-700">{message}</div>}
            {error && <div className="mb-4 rounded-lg bg-red-100 p-3 text-red-700">{error}</div>}

            <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
                <form onSubmit={handleProfileSave} className="rounded-lg bg-white p-8 shadow-lg">
                    <h2 className="mb-6 text-2xl font-bold text-gray-800">Basic Info</h2>
                    <div className="mb-4">
                        <label className="mb-2 block font-semibold text-gray-700">Name</label>
                        <input
                            value={profile.name}
                            onChange={(e) => setProfile((prev) => ({ ...prev, name: e.target.value }))}
                            className="w-full rounded-lg border border-gray-300 px-4 py-2"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="mb-2 block font-semibold text-gray-700">Phone</label>
                        <input
                            value={profile.phone}
                            onChange={(e) => setProfile((prev) => ({ ...prev, phone: e.target.value }))}
                            className="w-full rounded-lg border border-gray-300 px-4 py-2"
                        />
                    </div>
                    <div className="mb-6">
                        <label className="mb-2 block font-semibold text-gray-700">Bio</label>
                        <textarea
                            rows="4"
                            value={profile.bio}
                            onChange={(e) => setProfile((prev) => ({ ...prev, bio: e.target.value }))}
                            className="w-full rounded-lg border border-gray-300 px-4 py-2"
                        />
                    </div>
                    <button type="submit" className="rounded-lg bg-emerald-600 px-6 py-2 text-white hover:bg-emerald-700">Save Profile</button>
                </form>

                <form onSubmit={handlePasswordSave} className="rounded-lg bg-white p-8 shadow-lg">
                    <h2 className="mb-6 text-2xl font-bold text-gray-800">Change Password</h2>
                    <div className="mb-4">
                        <label className="mb-2 block font-semibold text-gray-700">Current Password</label>
                        <input
                            type="password"
                            value={passwords.current_password}
                            onChange={(e) => setPasswords((prev) => ({ ...prev, current_password: e.target.value }))}
                            className="w-full rounded-lg border border-gray-300 px-4 py-2"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="mb-2 block font-semibold text-gray-700">New Password</label>
                        <input
                            type="password"
                            value={passwords.password}
                            onChange={(e) => setPasswords((prev) => ({ ...prev, password: e.target.value }))}
                            className="w-full rounded-lg border border-gray-300 px-4 py-2"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="mb-2 block font-semibold text-gray-700">Confirm New Password</label>
                        <input
                            type="password"
                            value={passwords.password_confirmation}
                            onChange={(e) => setPasswords((prev) => ({ ...prev, password_confirmation: e.target.value }))}
                            className="w-full rounded-lg border border-gray-300 px-4 py-2"
                            required
                        />
                    </div>
                    <button type="submit" className="rounded-lg bg-emerald-600 px-6 py-2 text-white hover:bg-emerald-700">Change Password</button>
                </form>
            </div>
        </div>
    );
};

export default Profile;
